import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";

function apostolates() {
  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Apostolates" breadcrumbName="Apostolates" />
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-7.jpg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-7.jpg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-8.jpg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-8.jpg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-9.jpg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-9.jpg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-4.jpeg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-4.jpeg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-3.jpeg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-3.jpeg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-2.jpg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-2.jpg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 gallery_desc">
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-1.jpg"
              >
                <LazyLoad offset={10}>
                  <img
                    src="https://webapi.entab.info/api/image/FSOLG/public/Images/apostolates-1.jpg"
                    alt="Franciscan Sisters of Our Lady Of Graces"
                    className="img-fluid galleryimg"
                  />
                </LazyLoad>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default apostolates;
